import { BaseTransform } from './BaseTransform';
import { IQueryOptions, IExecutionOptions } from '../../models/query';
import { camelCase } from '../../utils/changeCase';

export class GroupTransform extends BaseTransform {
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		const response: { [property: string]: object[]; } = {};
		const { groupTransformOptions } = this.options;
		if (queryResponse) {
			const { groupByKey } = groupTransformOptions;
			const groupByKeyValues = [...Array.from(new Set(queryResponse.map(element => element[groupByKey])))];
			for (const groupByKeyValue of groupByKeyValues) {
				response[camelCase(groupByKeyValue.toString())] = queryResponse.filter(element => element[groupByKey] === groupByKeyValue);
			}
		}
		return response;
	}
}